export { default } from './FareItemCard';
